import React, { useEffect } from 'react';
import { shape, string } from 'prop-types';
import { PageLoader } from '@kallidus/common';
import { useLazyQuery } from '@apollo/client';
import { doesAppVersionMatch, isChunkLoadError, triggerVersionMismatch } from '@ApplicationWide/version-checking';
import VERSION_QUERY from './version.query.graphql';
import GenericErrorPage from './GenericErrorPage';

// intermediate component to check if the error
// is due to the app having been updated
const CodeErrorPage = ({ error }) => {
  const isChunkError = isChunkLoadError(error);
  const [getVersion, { loading, data: { version } = {} }] = useLazyQuery(VERSION_QUERY, { fetchPolicy: 'no-cache' });
  const versionMismatch = version && !doesAppVersionMatch(version);
  useEffect(() => {
    if (isChunkError) {
      getVersion();
    }
  }, [isChunkError, getVersion]);
  useEffect(() => {
    if (versionMismatch) {
      triggerVersionMismatch(version);
    }
  }, [version, versionMismatch]);

  if (isChunkError) {
    if (loading) {
      return <PageLoader />;
    }
    // return nothing in version mismatch cases
    // as we will rely on `triggerVersionMismatch()`
    // to render the system update modal
    if (versionMismatch) {
      return null;
    }
  }

  return <GenericErrorPage error={error} />;
};

CodeErrorPage.propTypes = {
  error: shape({ message: string }),
};

export default CodeErrorPage;
